import api from '../library/axios';

export default {
  get_setting({ id, company_id }) {
    return api({
      url: `/api/csat-settings/${id}/${company_id}`,
    });
  },
};
